var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnderline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 111.13 122.88",
    style: {
      enableBackground: "new 0 0 111.13 122.88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.62,0h52.58v2.8h-2.62c-3.95,0-6.67,0.41-8.16,1.23C43.93,4.85,42.88,6,42.27,7.44c-0.61,1.46-0.95,5.1-0.95,10.9v49.88 c0,9.13,0.69,15.16,2.08,18.13c1.39,2.95,3.64,5.39,6.8,7.36c3.15,1.95,7.13,2.92,11.95,2.92c5.51,0,10.21-1.23,14.08-3.72 c3.9-2.49,6.8-5.9,8.72-10.26c1.92-4.36,2.9-11.95,2.9-22.78V18.34c0-4.57-0.49-7.82-1.44-9.77c-0.95-1.95-2.16-3.31-3.59-4.05 c-2.26-1.15-5.44-1.72-9.57-1.72V0h35.24v2.8h-2.1c-2.85,0-5.23,0.57-7.13,1.72c-1.9,1.15-3.28,2.87-4.13,5.18 c-0.64,1.62-0.97,4.49-0.97,8.64v38.7c0,11.98-0.79,20.62-2.36,25.93c-1.59,5.31-5.44,10.18-11.54,14.64 c-6.1,4.46-14.47,6.69-25.03,6.69c-8.8,0-15.62-1.18-20.44-3.54c-6.54-3.21-11.18-7.31-13.9-12.31 c-2.69-5.03-4.05-11.75-4.05-20.24V18.34c0-5.85-0.31-9.49-0.97-10.93C15.21,5.98,14.08,4.85,12.46,4 C10.87,3.13,7.92,2.74,3.62,2.8V0L3.62,0z M0,115.89h111.13v7H0V115.89L0,115.89z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/underline.fad93ae76dd2edd295d0030634b2daa9.svg";
export { ForwardRef as ReactComponent };